import type { Employee, Loan } from '../types/comp'

export const employees: Employee[] = [
  {
    id: 'emp-1',
    name: 'Jordan Ellis',
    role: 'Senior Loan Officer',
    team: 'West Coast Funding',
    currentBps: 120,
    currentShortPct: 60,
  },
  {
    id: 'emp-2',
    name: 'Priya Raman',
    role: 'Loan Officer',
    team: 'Mountain Region',
    currentBps: 95,
    currentShortPct: 50,
  },
  {
    id: 'emp-3',
    name: 'Marcus Webb',
    role: 'Producing Branch Manager',
    team: 'Southeast',
    currentBps: 140,
    currentShortPct: 70,
  },
]

export const loans: Loan[] = [
  // Jordan Ellis
  { id: 'LN-20419', name: 'Harborview Refi', employeeId: 'emp-1', loanType: 'full', amount: 685000, fundedDate: '2026-01-14', currentCommission: 8220 },
  { id: 'LN-20527', name: 'Castro Duplex Purchase', employeeId: 'emp-1', loanType: 'full', amount: 1240000, fundedDate: '2026-02-02', currentCommission: 14880 },
  { id: 'LN-20603', name: 'Sunset Bridge Loan', employeeId: 'emp-1', loanType: 'short', amount: 320000, fundedDate: '2026-02-21', currentCommission: 2304 },
  { id: 'LN-20744', name: 'Alameda Cash-Out', employeeId: 'emp-1', loanType: 'full', amount: 540000, fundedDate: '2026-03-30', currentCommission: 6480 },
  { id: 'LN-20812', name: 'Pinecrest Construction Draw', employeeId: 'emp-1', loanType: 'short', amount: 275000, fundedDate: '2026-04-16', currentCommission: 1980 },
  { id: 'LN-20958', name: 'Lakeshore Portfolio Refi', employeeId: 'emp-1', loanType: 'full', amount: 2100000, fundedDate: '2026-05-27', currentCommission: 25200 },
  { id: 'LN-21033', name: 'Marina Heights Purchase', employeeId: 'emp-1', loanType: 'full', amount: 880000, fundedDate: '2026-06-08', currentCommission: 10560 },
  { id: 'LN-21140', name: 'Willow Park Gap Loan', employeeId: 'emp-1', loanType: 'short', amount: 195000, fundedDate: '2026-07-19', currentCommission: 1404 },
  { id: 'LN-21288', name: 'Bayfront Mixed-Use', employeeId: 'emp-1', loanType: 'full', amount: 1650000, fundedDate: '2026-07-30', currentCommission: 19800 },
  { id: 'LN-21377', name: 'Redwood Second Position', employeeId: 'emp-1', loanType: 'short', amount: 240000, fundedDate: '2026-08-24', currentCommission: 1728 },
  { id: 'LN-21455', name: 'Orchard Lane Purchase', employeeId: 'emp-1', loanType: 'full', amount: 615000, fundedDate: '2026-09-04', currentCommission: 7380 },

  // Priya Raman
  { id: 'LN-19880', name: 'Cedar Grove Purchase', employeeId: 'emp-2', loanType: 'full', amount: 430000, fundedDate: '2026-01-22', currentCommission: 4085 },
  { id: 'LN-20122', name: 'Aspen Ridge Refi', employeeId: 'emp-2', loanType: 'full', amount: 520000, fundedDate: '2026-03-11', currentCommission: 4940 },
  { id: 'LN-20344', name: 'Boulder Flats Bridge', employeeId: 'emp-2', loanType: 'short', amount: 180000, fundedDate: '2026-04-29', currentCommission: 855 },
  { id: 'LN-20690', name: 'Summit Park Purchase', employeeId: 'emp-2', loanType: 'full', amount: 760000, fundedDate: '2026-06-17', currentCommission: 7220 },
  { id: 'LN-21010', name: 'Highline Cash-Out', employeeId: 'emp-2', loanType: 'full', amount: 395000, fundedDate: '2026-08-05', currentCommission: 3752 },

  // Marcus Webb
  { id: 'LN-19755', name: 'Palmetto Bay Purchase', employeeId: 'emp-3', loanType: 'full', amount: 910000, fundedDate: '2026-02-09', currentCommission: 12740 },
  { id: 'LN-20201', name: 'Gulfview Refi', employeeId: 'emp-3', loanType: 'full', amount: 1150000, fundedDate: '2026-04-03', currentCommission: 16100 },
  { id: 'LN-20555', name: 'Magnolia Short Sale', employeeId: 'emp-3', loanType: 'short', amount: 260000, fundedDate: '2026-05-15', currentCommission: 2548 },
  { id: 'LN-21099', name: 'Riverbend Construction', employeeId: 'emp-3', loanType: 'short', amount: 340000, fundedDate: '2026-07-08', currentCommission: 3332 },
  { id: 'LN-21402', name: 'Coral Way Purchase', employeeId: 'emp-3', loanType: 'full', amount: 705000, fundedDate: '2026-09-01', currentCommission: 9870 },
]
